<template>
  <div class="autocomplete-wrapper">
    <label v-if="label" class="input-label">{{ label }}</label>
    <div class="input-container" :class="{ error: error }">
      <input
        type="text"
        :value="modelValue"
        @input="
          $emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
        :placeholder="placeholder"
        class="input-field"
        @focus="showDropdown = true"
      />
    </div>
    <div v-if="showDropdown && options.length > 0" class="options-dropdown">
      <div
        v-for="(option, index) in options"
        :key="index"
        class="option-item"
        @click="selectOption(option)"
      >
        {{ option }}
      </div>
    </div>
    <div v-if="error && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

defineProps<{
  modelValue: string;
  options: string[];
  label?: string;
  placeholder?: string;
  error?: boolean;
  errorMessage?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const showDropdown = ref(false);

const selectOption = (option: string) => {
  emit("update:modelValue", option);
  showDropdown.value = false;
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.autocomplete-wrapper {
  position: relative;
  width: 100%;
}

.input-label {
  font-size: 14px;
  margin-bottom: 4px;
  color: $pj-color-cool-gray;
}

.input-container {
  border: 1px solid $pj-color-light-gray;
  border-radius: 11px;
  padding: 5px 20px;
  background-color: white;

  &.error {
    border-color: $pj-color-red;
  }
}

.input-field {
  width: 100%;
  height: 40px;
  border: none;
  font-size: 16px;
  font-weight: 600;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: $pj-color-cool-gray;
  }
}

.options-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid $pj-color-light-gray;
  border-radius: 8px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.option-item {
  padding: 12px 20px;
  cursor: pointer;

  &:hover {
    background-color: rgba($pj-color-light-gray, 0.2);
  }
}

.error-message {
  color: $pj-color-red;
  font-size: 12px;
  margin-top: 4px;
}
</style>
